import 'core-js/fn/string/includes';
import 'core-js/es7/array';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import App from './components/App';
// import registerServiceWorker from './registerServiceWorker';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

Sentry.init({
 dsn: "https://4398a3b184d6495d92ec4816ce92f912@sentry.io/1412049"
});

ReactDOM.render(<App></App>, document.getElementById('root'));

// registerServiceWorker();

// disable this service and clear the 'cache' for users who registered with it before.
// this seems to be messing with the prerendering
// for details, see ./registerServiceWorker and the documentation link mentioned there.
unregisterServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js